const currentClinic = {
  id: null,
};

function setGlobalCurrentClinic(clinicId) {
  currentClinic.id = clinicId;
}

export {
  currentClinic,
  setGlobalCurrentClinic,
};
